export function timestampToIso(timestamp: number | null): string | null {
  return timestamp ? new Date(timestamp).toISOString() : null;
}
